import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  MultiMediaResponse,
  MultiMediaResponseDTO,
} from 'dtos';
import {
  postApiMultimediaRequestMultiMedia,
} from 'endpoints';
import {
  getMultiMedia,
} from 'pages/Dashboard/services/api';
import {
  MultimediaType,
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import {
  MediaInfo,
} from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/MediaContents';
import {
  notEmptyString,
} from '@populateui/utils';

type UseGetPatientMediaByMultimediaTypeOptions = {
  generateUrls?: boolean;
  enabled?: boolean;
};

// Todo: check if needs to change to multimediaType
export default function useGetPatientMediaByMultimediaType(
  id: number,
  multimediaTypes: MultimediaType[],
  {
    generateUrls = true,
    enabled = true,
  }: UseGetPatientMediaByMultimediaTypeOptions = {},
): UseQueryResult<MultiMediaResponse[], Error> {
  const queryResult = useQuery<MultiMediaResponse[], Error>({
    queryKey: ['multimedia', id, multimediaTypes],
    queryFn: async () => {
      const results = await getMultiMedia(
        {
          generateUrls,
          list: multimediaTypes.map((multimediaType) => (
            {
              originatorType: MediaOriginatorType.Patient,
              originatorId: id,
              multimediaType,
            })),
        },
      );
      return results;
    },
    enabled: enabled && id > 0 && multimediaTypes.length > 0,
  });

  return queryResult;
}

export function useGetPatientMediaByMultimediaTypeWithPagination(
  id: number,
  mediaInfo: MediaInfo,
  generateUrls = true,
  page: number = 0,
  pageSize: number = 25,
): UseQueryResult<MultiMediaResponseDTO, Error> {
  const {
    multimediaTypes = [],
    mediaCategory,
  } = mediaInfo;

  const queryResult = useQuery<MultiMediaResponseDTO, Error>({
    queryKey: [
      'multimedia-pagination',
      id,
      ...(multimediaTypes ?? []),
      ...(notEmptyString(mediaCategory) ? [mediaCategory] : []),
      page,
      pageSize,
    ],
    queryFn: async () => {
      const results = await postApiMultimediaRequestMultiMedia(
        {
          generateUrls,
          list: [
            ...multimediaTypes.map((multimediaType) => (
              {
                originatorType: MediaOriginatorType.Patient,
                originatorId: id,
                multimediaType,
              })),
            ...(notEmptyString(mediaCategory)
              ? [{
                originatorType: MediaOriginatorType.Patient,
                originatorId: id,
                mediaCategory,
              }]
              : []),
          ],
          pageProperties: {
            page,
            pageSize,
          },
        },
      );
      return results;
    },
    enabled: id > 0 && (multimediaTypes.length > 0 || notEmptyString(mediaCategory)),
  });

  return queryResult;
}
